import { render, staticRenderFns } from "./bistro_set.vue?vue&type=template&id=f3044b7a&scoped=true"
import script from "./bistro_set.vue?vue&type=script&lang=js"
export * from "./bistro_set.vue?vue&type=script&lang=js"
import style0 from "./bistro_set.vue?vue&type=style&index=0&id=f3044b7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3044b7a",
  null
  
)

export default component.exports